import { WithId } from '@common/typescript/objects/WithId';
import { WithRemoved } from '@common/typescript/objects/WithRemoved';
import { Nullable } from '@common/typescript/objects/Nullable';

import { Price, PriceKind } from '@app/objects/Price';
import { User } from '@app/objects/User';
import { PickupService } from '@app/objects/PickupService';
import { StoreEntry, StoreEntryNode } from '@app/objects/StoreEntry';
import { Pet, isPreset, PetEngraving } from '@app/objects/Pet';
import { SpecialServiceType } from '@app/objects/SpecialService';

/**
 * This is a service that was actually added to pet
 * It caches price data at the moment when it was added to pet
 */
export interface PetPrice extends WithId, WithRemoved {
	clientId: string;

	petId: number;
	pet?: Nullable<Pet>;

	priceId: number;
	price?: Nullable<Price>;

	engravingId: Nullable<number>;
	engraving?: Nullable<PetEngraving>;

	count: number;
	completedCount: number;
	done: boolean;

	value: number;
	extra: number;
	discount: number;
	tax: number;

	name: string;

	editor: Nullable<User>;
	editorId: Nullable<number>;

	pickupService: Nullable<PickupService>;
	pickupServiceId: Nullable<number>;

	batchCount: number;
	batchPrice: number;

	entry?: Nullable<StoreEntry>;
	node: Nullable<StoreEntryNode>;
	nodeId: Nullable<number>;
	toSelect?: boolean;

	note: string;

	parent?: Nullable<PetPrice>;
	parentId?: Nullable<number>;
	children?: Array<PetPrice>;
}

export function clearPreset(items: Array<PetPrice>): Array<PetPrice> {
	return items
		.map((item: PetPrice) => (
			!isPreset(item)
				? item
				: { ...item, removed: true }
		))
		.filter((item: PetPrice) => !(item.removed && item.id <= 0));
}

export function isEngraving(item: PetPrice): boolean {
	return item.price?.priceKind === PriceKind.Engraving;
}

export function isKit(item: PetPrice): boolean {
	return item.price?.specialService?.specialServiceType === SpecialServiceType.Kit;
}

export function isKitService(item: PetPrice): boolean {
	return item.price?.specialService?.specialServiceType === SpecialServiceType.KitService;
}

export function isService(item: PetPrice): boolean {
	return item.price?.specialService?.specialServiceType === SpecialServiceType.Service;
}
